module.exports = __webpack_public_path__ + "img/p1.2a0e86f9.jpg";